import { createAsyncThunk } from "@reduxjs/toolkit";

import ActionsAgainstPerpetratorsAPI, {
    ActionsAgainstPerpetratorsResponse,
    UpsertActionsAgainstPerpetratorsRequest,
} from "../../../api/actions_against_perpetrators";
import { MessageResponse } from "../../../api/common";

export const fetchActionsAgainstPerpetratorsThunk = createAsyncThunk<
    ActionsAgainstPerpetratorsResponse,
    { caseId: string },
    { rejectValue: string }
>(
    "actionsAgainstPerpetrators/getAll",
    async ({ caseId }, { rejectWithValue }) => {
        try {
            return await ActionsAgainstPerpetratorsAPI.get(caseId);
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                    error.message ||
                    "Failed to fetch actions against perpetrators"
            );
        }
    },
    {
        condition({ caseId }, { getState }) {
            const s = (getState() as any).actionsAgainstPerpetratorsData;
            if (!s) return true;
            if (s.status === "loading") return false;
            if (s.status === "succeeded" && s.caseId === caseId) return false;
            return true;
        },
    }
);

export const upsertActionsAgainstPerpetratorsThunk = createAsyncThunk<
    MessageResponse,
    { caseId: string; request: UpsertActionsAgainstPerpetratorsRequest },
    { rejectValue: string }
>(
    "actionsAgainstPerpetrators/upsert",
    async ({ caseId, request }, { rejectWithValue }) => {
        try {
            return await ActionsAgainstPerpetratorsAPI.upsert(caseId, request);
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                    error.message ||
                    "Failed to save actions against perpetrators"
            );
        }
    }
);
